import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NavbarTxtsKey } from 'src/app/interfaces/texts/navbar-txt-key.interface';
import { TextsDataService } from 'src/app/services/texts-data.service';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

    @Input() logoGov?: string;
    texts?: NavbarTxtsKey;
    navbarClass: string = '';

    constructor(
        public router: Router,
        private textsDataService: TextsDataService
    ) {}

    ngOnInit(): void {
        this.getTexts();
    }

    getTexts(): void {
        this.textsDataService.getTextData().subscribe({
            next: (data) => {
                if (data?.navbar) {
                    this.texts = data.navbar;
                }
            },
            error: (error) => {
                // Error handling
            }
        });
    }

    toggleClass(): void {
        // Toggle navbar mobile class if needed
        const navbar = document.getElementById('targetElement');
        if (navbar?.classList.contains('show')) {
            navbar.classList.remove('show');
        } else {
            navbar?.classList.add('show');
        }
    }
}